import React from 'react';
import { Link } from 'react-router-dom';

const About: React.FC = () => {
  return (
    <section id="about" className="section section-alt">
      <div className="container">
        <div style={{ textAlign: 'center', marginBottom: '4rem' }}>
          <h2 className="section-title">About RapidNova</h2>
          <div className="section-divider"></div>
        </div>

        <div className="grid grid-2" style={{ alignItems: 'center', marginBottom: '5rem' }}>
          <div>
            <h3 style={{ fontSize: '1.5rem', fontWeight: '600', marginBottom: '1.5rem', color: 'inherit' }}>
              Our Mission
            </h3>
            <p style={{ fontSize: '1.125rem', lineHeight: '1.75', marginBottom: '2rem', color: 'inherit' }}>
              At RapidNova, we identify everyday challenges and transform them into opportunities 
              through innovative mobile applications. Our mission is to create products that make 
              life simpler, more efficient, and more enjoyable for users around the world. We focus 
              on building apps that solve genuine problems with elegant, user-friendly solutions.
            </p>
            
            <ul className="feature-list">
              <li className="feature-item">
                <div className="feature-dot"></div>
                <span>User-centered product development</span>
              </li>
              <li className="feature-item">
                <div className="feature-dot"></div>
                <span>Solving real-world problems</span>
              </li>
              <li className="feature-item">
                <div className="feature-dot"></div>
                <span>Quality-driven app creation</span>
              </li>
            </ul>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>
            <div className="card">
              <h4 style={{ fontSize: '1.125rem', fontWeight: '600', marginBottom: '0.5rem', color: 'inherit' }}>
                Founded
              </h4>
              <p>2025</p>
            </div>

            <div className="card">
              <h4 style={{ fontSize: '1.125rem', fontWeight: '600', marginBottom: '0.5rem', color: 'inherit' }}>
                Platforms
              </h4>
              <div className="platform-icons">
                <div className="platform-icon">
                  <div className="platform-badge ios">iOS</div>
                  <span>iOS</span>
                </div>
                <div className="platform-icon">
                  <div className="platform-badge android">A</div>
                  <span>Android</span>
                </div>
              </div>
            </div>

            <div className="card">
              <h4 style={{ fontSize: '1.125rem', fontWeight: '600', marginBottom: '0.5rem', color: 'inherit' }}>
                Focus
              </h4>
              <p>Consumer Mobile Apps</p>
            </div>
          </div>
        </div>

        {/* Our Apps Section */}
        <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
          <h2 className="section-title">Our Apps</h2>
          <div className="section-divider"></div>
        </div>

        <div style={{ maxWidth: '800px', margin: '0 auto', display: 'flex', flexDirection: 'column', gap: '3rem' }}>
          {/* OCRacle App */}
          <div className="card" style={{ padding: '3rem', textAlign: 'center' }}>
            <div style={{ marginBottom: '2rem' }}>
              <h3 style={{ 
                fontSize: '2rem', 
                fontWeight: '700', 
                marginBottom: '1rem', 
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }}>
                OCRacle
              </h3>
              <p style={{ 
                fontSize: '1.125rem', 
                color: 'var(--text-light)', 
                marginBottom: '2rem',
                lineHeight: '1.6'
              }}>
                A privacy-focused OCR (Optical Character Recognition) mobile application that 
                transforms your images into editable text. OCRacle processes everything locally 
                on your device, ensuring your documents remain private and secure.
              </p>
            </div>

            <div style={{ 
              display: 'flex', 
              justifyContent: 'center', 
              gap: '1rem', 
              marginBottom: '2rem',
              flexWrap: 'wrap'
            }}>
              <div style={{ 
                padding: '0.5rem 1rem', 
                backgroundColor: 'var(--accent-color)', 
                color: 'white',
                borderRadius: '20px',
                fontSize: '0.875rem',
                fontWeight: '500'
              }}>
                📱 Mobile App
              </div>
              <div style={{ 
                padding: '0.5rem 1rem', 
                backgroundColor: 'var(--success-color)', 
                color: 'white',
                borderRadius: '20px',
                fontSize: '0.875rem',
                fontWeight: '500'
              }}>
                🔒 Privacy First
              </div>
              <div style={{ 
                padding: '0.5rem 1rem', 
                backgroundColor: 'var(--info-color)', 
                color: 'white',
                borderRadius: '20px',
                fontSize: '0.875rem',
                fontWeight: '500'
              }}>
                📄 OCR Technology
              </div>
            </div>

            <Link 
              to="/apps/ocracle/privacy-policy" 
              style={{
                display: 'inline-block',
                padding: '1rem 2rem',
                backgroundColor: 'var(--accent-color)',
                color: 'white',
                textDecoration: 'none',
                borderRadius: '50px',
                fontWeight: '600',
                fontSize: '1rem',
                transition: 'all 0.3s ease',
                boxShadow: '0 4px 15px rgba(102, 126, 234, 0.3)'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 6px 20px rgba(102, 126, 234, 0.4)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 15px rgba(102, 126, 234, 0.3)';
              }}
            >
              View Privacy Policy
            </Link>
          </div>

          {/* CleanMind App */}
          <div className="card" style={{ padding: '3rem', textAlign: 'center' }}>
            <div style={{ marginBottom: '2rem' }}>
              <h3 style={{ 
                fontSize: '2rem', 
                fontWeight: '700', 
                marginBottom: '1rem', 
                background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }}>
                Ai Storage Cleaner - CleanMind
              </h3>
              <p style={{ 
                fontSize: '1.125rem', 
                color: 'var(--text-light)', 
                marginBottom: '2rem',
                lineHeight: '1.6'
              }}>
                An intelligent iOS storage management app that uses AI to help you reclaim valuable 
                device storage. CleanMind analyzes your photos, videos, and files to identify duplicates, 
                similar images, and unnecessary files, making storage cleanup effortless and smart.
              </p>
            </div>

            <div style={{ 
              display: 'flex', 
              justifyContent: 'center', 
              gap: '1rem', 
              marginBottom: '2rem',
              flexWrap: 'wrap'
            }}>
              <div style={{ 
                padding: '0.5rem 1rem', 
                backgroundColor: 'var(--accent-color)', 
                color: 'white',
                borderRadius: '20px',
                fontSize: '0.875rem',
                fontWeight: '500'
              }}>
                📱 iOS App
              </div>
              <div style={{ 
                padding: '0.5rem 1rem', 
                backgroundColor: 'var(--success-color)', 
                color: 'white',
                borderRadius: '20px',
                fontSize: '0.875rem',
                fontWeight: '500'
              }}>
                🤖 AI-Powered
              </div>
              <div style={{ 
                padding: '0.5rem 1rem', 
                backgroundColor: 'var(--info-color)', 
                color: 'white',
                borderRadius: '20px',
                fontSize: '0.875rem',
                fontWeight: '500'
              }}>
                🗂️ Storage Cleaner
              </div>
            </div>

            <Link 
              to="/apps/cleanmind/privacy-policy" 
              style={{
                display: 'inline-block',
                padding: '1rem 2rem',
                backgroundColor: '#4facfe',
                color: 'white',
                textDecoration: 'none',
                borderRadius: '50px',
                fontWeight: '600',
                fontSize: '1rem',
                transition: 'all 0.3s ease',
                boxShadow: '0 4px 15px rgba(79, 172, 254, 0.3)'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 6px 20px rgba(79, 172, 254, 0.4)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 15px rgba(79, 172, 254, 0.3)';
              }}
            >
              View Privacy Policy
            </Link>
          </div>

          {/* Artrix App */}
          <div className="card" style={{ padding: '3rem', textAlign: 'center' }}>
            <div style={{ marginBottom: '2rem' }}>
              <h3 style={{ 
                fontSize: '2rem', 
                fontWeight: '700', 
                marginBottom: '1rem', 
                background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }}>
                Artrix - Dall E 3 Image AI
              </h3>
              <p style={{ 
                fontSize: '1.125rem', 
                color: 'var(--text-light)', 
                marginBottom: '2rem',
                lineHeight: '1.6'
              }}>
                An AI-powered creative platform that transforms your ideas into stunning artwork. 
                Artrix leverages OpenAI's DALL-E 3 to generate unique, high-quality images from text 
                prompts, making professional-grade art creation accessible to everyone.
              </p>
            </div>

            <div style={{ 
              display: 'flex', 
              justifyContent: 'center', 
              gap: '1rem', 
              marginBottom: '2rem',
              flexWrap: 'wrap'
            }}>
              <div style={{ 
                padding: '0.5rem 1rem', 
                backgroundColor: 'var(--accent-color)', 
                color: 'white',
                borderRadius: '20px',
                fontSize: '0.875rem',
                fontWeight: '500'
              }}>
                📱 iOS App
              </div>
              <div style={{ 
                padding: '0.5rem 1rem', 
                backgroundColor: 'var(--success-color)', 
                color: 'white',
                borderRadius: '20px',
                fontSize: '0.875rem',
                fontWeight: '500'
              }}>
                🎨 AI Art Generator
              </div>
              <div style={{ 
                padding: '0.5rem 1rem', 
                backgroundColor: 'var(--info-color)', 
                color: 'white',
                borderRadius: '20px',
                fontSize: '0.875rem',
                fontWeight: '500'
              }}>
                ⚡ DALL-E 3 Powered
              </div>
            </div>

            <Link 
              to="/apps/artrix/privacy-policy" 
              style={{
                display: 'inline-block',
                padding: '1rem 2rem',
                backgroundColor: '#f093fb',
                color: 'white',
                textDecoration: 'none',
                borderRadius: '50px',
                fontWeight: '600',
                fontSize: '1rem',
                transition: 'all 0.3s ease',
                boxShadow: '0 4px 15px rgba(240, 147, 251, 0.3)'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 6px 20px rgba(240, 147, 251, 0.4)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 15px rgba(240, 147, 251, 0.3)';
              }}
            >
              View Privacy Policy
            </Link>
          </div>

          {/* AiDG - AI Dance Generator App */}
          <div className="card" style={{ padding: '3rem', textAlign: 'center' }}>
            <div style={{ marginBottom: '2rem' }}>
              <h3 style={{ 
                fontSize: '2rem', 
                fontWeight: '700', 
                marginBottom: '1rem', 
                background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }}>
                AiDG - AI Dance Generator
              </h3>
              <p style={{ 
                fontSize: '1.125rem', 
                color: 'var(--text-light)', 
                marginBottom: '2rem',
                lineHeight: '1.6'
              }}>
                Create dance videos from a reference photo and a reference dance (photo or video). 
                An iOS app that brings your photos to life with AI-powered dance generation.
              </p>
            </div>

            <div style={{ 
              display: 'flex', 
              justifyContent: 'center', 
              gap: '1rem', 
              marginBottom: '2rem',
              flexWrap: 'wrap'
            }}>
              <div style={{ 
                padding: '0.5rem 1rem', 
                backgroundColor: 'var(--accent-color)', 
                color: 'white',
                borderRadius: '20px',
                fontSize: '0.875rem',
                fontWeight: '500'
              }}>
                iOS App
              </div>
              <div style={{ 
                padding: '0.5rem 1rem', 
                backgroundColor: 'var(--success-color)', 
                color: 'white',
                borderRadius: '20px',
                fontSize: '0.875rem',
                fontWeight: '500'
              }}>
                AI Dance Generator
              </div>
              <div style={{ 
                padding: '0.5rem 1rem', 
                backgroundColor: 'var(--info-color)', 
                color: 'white',
                borderRadius: '20px',
                fontSize: '0.875rem',
                fontWeight: '500'
              }}>
                Video Generation
              </div>
            </div>

            <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
              <Link 
                to="/apps/aidg/privacy-policy" 
                style={{
                  display: 'inline-block',
                  padding: '1rem 2rem',
                  backgroundColor: '#11998e',
                  color: 'white',
                  textDecoration: 'none',
                  borderRadius: '50px',
                  fontWeight: '600',
                  fontSize: '1rem',
                  transition: 'all 0.3s ease',
                  boxShadow: '0 4px 15px rgba(17, 153, 142, 0.3)'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = '0 6px 20px rgba(17, 153, 142, 0.4)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 4px 15px rgba(17, 153, 142, 0.3)';
                }}
              >
                View Privacy Policy
              </Link>
              <Link 
                to="/apps/aidg/terms-of-service" 
                style={{
                  display: 'inline-block',
                  padding: '1rem 2rem',
                  backgroundColor: 'transparent',
                  color: '#11998e',
                  textDecoration: 'none',
                  borderRadius: '50px',
                  fontWeight: '600',
                  fontSize: '1rem',
                  border: '2px solid #11998e',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = 'rgba(17, 153, 142, 0.1)';
                  e.currentTarget.style.transform = 'translateY(-2px)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'transparent';
                  e.currentTarget.style.transform = 'translateY(0)';
                }}
              >
                View Terms of Service
              </Link>
            </div>
          </div>

          {/* Bank Statement Converter App */}
          <div className="card" style={{ padding: '3rem', textAlign: 'center' }}>
            <div style={{ marginBottom: '2rem' }}>
              <h3 style={{ 
                fontSize: '2rem', 
                fontWeight: '700', 
                marginBottom: '1rem', 
                background: 'linear-gradient(135deg, #0f4c81 0%, #1a73e8 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }}>
                Bank Statement Converter
              </h3>
              <p style={{ 
                fontSize: '1.125rem', 
                color: 'var(--text-light)', 
                marginBottom: '2rem',
                lineHeight: '1.6'
              }}>
                Convert bank statements from PDF or scans into structured transactions you can review 
                and export. An iOS app that keeps your statement library on your device while using 
                secure cloud processing only during import.
              </p>
            </div>

            <div style={{ 
              display: 'flex', 
              justifyContent: 'center', 
              gap: '1rem', 
              marginBottom: '2rem',
              flexWrap: 'wrap'
            }}>
              <div style={{ 
                padding: '0.5rem 1rem', 
                backgroundColor: 'var(--accent-color)', 
                color: 'white',
                borderRadius: '20px',
                fontSize: '0.875rem',
                fontWeight: '500'
              }}>
                iOS App
              </div>
              <div style={{ 
                padding: '0.5rem 1rem', 
                backgroundColor: 'var(--success-color)', 
                color: 'white',
                borderRadius: '20px',
                fontSize: '0.875rem',
                fontWeight: '500'
              }}>
                Statement Converter
              </div>
              <div style={{ 
                padding: '0.5rem 1rem', 
                backgroundColor: 'var(--info-color)', 
                color: 'white',
                borderRadius: '20px',
                fontSize: '0.875rem',
                fontWeight: '500'
              }}>
                CSV / Excel / OFX
              </div>
            </div>

            <Link 
              to="/apps/bank-statement-converter/privacy-policy" 
              style={{
                display: 'inline-block',
                padding: '1rem 2rem',
                backgroundColor: '#0f4c81',
                color: 'white',
                textDecoration: 'none',
                borderRadius: '50px',
                fontWeight: '600',
                fontSize: '1rem',
                transition: 'all 0.3s ease',
                boxShadow: '0 4px 15px rgba(15, 76, 129, 0.3)'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 6px 20px rgba(15, 76, 129, 0.4)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 15px rgba(15, 76, 129, 0.3)';
              }}
            >
              View Privacy Policy
            </Link>
          </div>

          {/* CPG - Chord Progression Generator App */}
          <div className="card" style={{ padding: '3rem', textAlign: 'center' }}>
            <div style={{ marginBottom: '2rem' }}>
              <h3 style={{ 
                fontSize: '2rem', 
                fontWeight: '700', 
                marginBottom: '1rem', 
                background: 'linear-gradient(135deg, #7c3aed 0%, #db2777 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }}>
                Chord Progression Generator
              </h3>
              <p style={{ 
                fontSize: '1.125rem', 
                color: 'var(--text-light)', 
                marginBottom: '2rem',
                lineHeight: '1.6'
              }}>
                Generate, practice, save, and export chord progressions. An iOS app for musicians 
                who want AI-assisted charts with moods, keys, instruments, and export options.
              </p>
            </div>

            <div style={{ 
              display: 'flex', 
              justifyContent: 'center', 
              gap: '1rem', 
              marginBottom: '2rem',
              flexWrap: 'wrap'
            }}>
              <div style={{ 
                padding: '0.5rem 1rem', 
                backgroundColor: 'var(--accent-color)', 
                color: 'white',
                borderRadius: '20px',
                fontSize: '0.875rem',
                fontWeight: '500'
              }}>
                iOS App
              </div>
              <div style={{ 
                padding: '0.5rem 1rem', 
                backgroundColor: 'var(--success-color)', 
                color: 'white',
                borderRadius: '20px',
                fontSize: '0.875rem',
                fontWeight: '500'
              }}>
                Chord Generator
              </div>
              <div style={{ 
                padding: '0.5rem 1rem', 
                backgroundColor: 'var(--info-color)', 
                color: 'white',
                borderRadius: '20px',
                fontSize: '0.875rem',
                fontWeight: '500'
              }}>
                AI Music Tools
              </div>
            </div>

            <Link 
              to="/apps/cpg/privacy-policy" 
              style={{
                display: 'inline-block',
                padding: '1rem 2rem',
                backgroundColor: '#7c3aed',
                color: 'white',
                textDecoration: 'none',
                borderRadius: '50px',
                fontWeight: '600',
                fontSize: '1rem',
                transition: 'all 0.3s ease',
                boxShadow: '0 4px 15px rgba(124, 58, 237, 0.3)'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 6px 20px rgba(124, 58, 237, 0.4)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 15px rgba(124, 58, 237, 0.3)';
              }}
            >
              View Privacy Policy
            </Link>
          </div>

          {/* OneTap App */}
          <div className="card" style={{ padding: '3rem', textAlign: 'center' }}>
            <div style={{ marginBottom: '2rem' }}>
              <h3 style={{ 
                fontSize: '2rem', 
                fontWeight: '700', 
                marginBottom: '1rem', 
                background: 'linear-gradient(135deg, #ea580c 0%, #f59e0b 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text'
              }}>
                OneTap
              </h3>
              <p style={{ 
                fontSize: '1.125rem', 
                color: 'var(--text-light)', 
                marginBottom: '2rem',
                lineHeight: '1.6'
              }}>
                Update all my apps in one tap. An iOS utility that helps you open App Store updates 
                quickly and view basic device information on your iPhone.
              </p>
            </div>

            <div style={{ 
              display: 'flex', 
              justifyContent: 'center', 
              gap: '1rem', 
              marginBottom: '2rem',
              flexWrap: 'wrap'
            }}>
              <div style={{ 
                padding: '0.5rem 1rem', 
                backgroundColor: 'var(--accent-color)', 
                color: 'white',
                borderRadius: '20px',
                fontSize: '0.875rem',
                fontWeight: '500'
              }}>
                iOS App
              </div>
              <div style={{ 
                padding: '0.5rem 1rem', 
                backgroundColor: 'var(--success-color)', 
                color: 'white',
                borderRadius: '20px',
                fontSize: '0.875rem',
                fontWeight: '500'
              }}>
                App Updates
              </div>
              <div style={{ 
                padding: '0.5rem 1rem', 
                backgroundColor: 'var(--info-color)', 
                color: 'white',
                borderRadius: '20px',
                fontSize: '0.875rem',
                fontWeight: '500'
              }}>
                Privacy-Friendly
              </div>
            </div>

            <Link 
              to="/apps/onetap/privacy-policy" 
              style={{
                display: 'inline-block',
                padding: '1rem 2rem',
                backgroundColor: '#ea580c',
                color: 'white',
                textDecoration: 'none',
                borderRadius: '50px',
                fontWeight: '600',
                fontSize: '1rem',
                transition: 'all 0.3s ease',
                boxShadow: '0 4px 15px rgba(234, 88, 12, 0.3)'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 6px 20px rgba(234, 88, 12, 0.4)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 15px rgba(234, 88, 12, 0.3)';
              }}
            >
              View Privacy Policy
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About; 